'use client';

import ContentSection from '@/storyblok/wirfuersklima/functionalComponents/contentSection/ContentSection';
import { nl2br } from '@/storyblok/wirfuersklima/helper/utils';
import type { SectionGoalYearStoryblok } from '@/storyblok/wirfuersklima/types';
import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';

import classes from './SectionGoalYear.module.scss';

const LottieAnimation = dynamic(() =>
  import('@/storyblok/wirfuersklima/functionalComponents/LottieAnimation').then((mod) => mod.LottieAnimation)
);

const SectionGoalYear: React.FC<{ blok: SectionGoalYearStoryblok }> = ({ blok }) => {
  const { ref, inView } = useInView({ triggerOnce: true, rootMargin: '200px 0px' });
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const update = (): void => {
      setIsMobile(window.matchMedia('(max-width: 767px)').matches);
    };
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);
  const frameCount = Number(blok.animationFrames);
  return (
    <div ref={ref}>
      <ContentSection blok={blok} className={classes['section-goal-year']} anchorId={blok.anchor_id} useWrapper>
        {blok.animationMobile && (
          <div className={classes['section-goal-year__animation--mobile']}>
            {inView && isMobile && (
              <LottieAnimation
                path={blok.animationMobile.filename || undefined}
                frames={frameCount}
                renderer="canvas"
                aspectRatio="330 / 440"
              />
            )}
          </div>
        )}
        {blok.animationDesktop && (
          <div className={classes['section-goal-year__animation--desktop']}>
            {inView && !isMobile && (
              <LottieAnimation
                path={blok.animationDesktop.filename || undefined}
                frames={frameCount}
                renderer="canvas"
              />
            )}
          </div>
        )}
        {/* eslint-disable-next-line react/no-danger -- legacy campaign: plain text with nl2br */}
        <p dangerouslySetInnerHTML={{ __html: nl2br(blok.text, true, true) }} />
      </ContentSection>
    </div>
  );
};

export default SectionGoalYear;
